import { jsPDF } from "jspdf";

import { ServiceLocator } from "@bbwt/utils/ServiceLocator";
import { FormioHtmlParserService } from "@features/bb-formio/classes/pdf-generator/formio-html-parser.service";
import { FormioHTMLData } from "@main/formio/components/formio-pdf/formio-pdf-generator.component";
import { IReportGenerator } from "./IReportGenerator";
import { IReportResource } from "./IReportResource";
import { PDFLibrary } from "./pdf-libraries";
import { FormioPDFGeneratorService } from "@features/bb-formio/services/formio-pdf-generator.service";

export abstract class BasePdfReportAbstract implements IReportGenerator {
    protected doc: jsPDF;

    private readonly _baseResource: IReportResource;

    // Services
    private readonly _formioHtmlParserService = ServiceLocator.injector.get(FormioHtmlParserService);
    private readonly _pdfGenerationService = ServiceLocator.injector.get(FormioPDFGeneratorService);

    /**
     *
     */
    constructor(baseResource: IReportResource) {
        this._baseResource = baseResource;
        this.doc = new jsPDF("p", "mm", "letter");
    }

    /**
    * IMPORTANT: DO NOT override this method.
    **/
    generateReport = async () => {
        // This.doc.setProperties({ title: `${this.reportName}` });

        // Const returnPromise = new Promise();

        const reportData: FormioHTMLData = this.getPDFReportData();

        if (this._baseResource.library === PDFLibrary.jsPDF) {

            this.doc.html(reportData.htmlContent, {
                margin: [10, 10, 10, 10],
                autoPaging: "text",
                x: 0,
                y: 0,
                width: 190, //Target width in the PDF document
                windowWidth: 675, //Window width in CSS pixels
                callback: function (pdf) {
                    // Save the PDF or display it as needed
                    window.open(pdf.output("bloburl"), "_blank");
                    // Pdf.save("HTMLGeneratioNTest" + ".pdf");
                }
            });
        }

        if (this._baseResource.library === PDFLibrary.jsReport) {

            const blob = await this._pdfGenerationService.generateFromFormio(this.getPDFReportData());
            this.openPdf(blob);
        }
    }

    private getPDFReportData = (): FormioHTMLData => {
        const htmlContent = this._baseResource.html;

        const jsonData = this._baseResource.jsonData;

        const parsedHtml = this._formioHtmlParserService.parse(htmlContent, jsonData);

        return {
            htmlContent: parsedHtml.body.innerHTML,
            formData: this._baseResource.jsonData
        };
    }

    private openPdf(blob: Blob): void {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.target = "_blank";
        // Set the PDF name
        link.download = this._baseResource.formDefinitionName;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

}